import Icon from '../components/Icon.vue'

Icon.register({"street-view":{"width":512,"height":512,"paths":[{"d":"M192 64C192 28.7 220.7 0 256 0S320 28.7 320 64C320 99.3 291.3 128 256 128S192 99.3 192 64zM304 144H292.6C269.9 154.4 243.1 154.9 219.4 144H208C181.5 144 160 165.5 160 192V296C160 309.3 170.7 320 184 320H200V424C200 437.3 210.7 448 224 448H288C301.3 448 312 437.3 312 424V320H328C341.3 320 352 309.3 352 296V192C352 165.5 330.5 144 304 144zM389.6 333.2A72.5-72.5 0 0 0 360.6 360.2C391.1 365.3 480 385.9 480 416 480 462.3 312.3 480 256 480 185.7 480 32 459.1 32 416 32 385.9 120.4 365.3 151.4 360.2A72.5-72.5 0 0 0 122.4 333.2C75 343.4 0 367.6 0 416 0 493.1 178.7 512 256 512 333.2 512 512 493.1 512 416 512 367.6 437 343.4 389.6 333.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/street-view.js
// module id = X6nE
// module chunks = 0